var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.994,
    height: 18,
    viewBox: "0 0 17.994 18",
    fill: "#ff5100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#222;opacity:.7}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    d: "M11.894 5.33l-8.781 8.78-.574 1.959 1.919-.555 8.81-8.81-1.374-1.374zm1.5-1.5l1.374 1.374 1.281-1.281a.486.486 0 0 0 0-.687l-.688-.687a.486.486 0 0 0-.687 0l-1.281 1.282zm3.341-2.654l.687.687a2.429 2.429 0 0 1 0 3.434L5.478 17.242l-4.1 1.185a.972.972 0 0 1-1.2-1.206l1.212-4.134L13.3 1.176a2.429 2.429 0 0 1 3.434 0z",
    className: "cls-1",
    transform: "translate(-.137 -.465)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.e721f3c36f4b0a0aa494048d54656d6d.svg";